<!-- <ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' ,fullScreenBackdrop:true}"></ngx-loading> -->
<main class="main-site-wrap wrapper">
    <app-header></app-header>
    <div class="site-content-wrap position-relative">
        <app-sidebar></app-sidebar>

        <!--start page wrapper -->
        <div class="page-wrapper">

            <!-- Start Create Subscription Album -->
            <div class="page-content">

                <!--breadcrumb-->
                <div class="page-breadcrumb mb-1 pb-3">
                    <div class="row align-items-center">
                        <div class="col-12">
                            <div class="d-flex align-items-center justify-content-start">
                                <a routerLink="/profile" class="btn ic-fill-btn">
                                    <i class="fa-solid fa-arrow-left"></i>
                                </a>
                                <h3 class="breadcrumb-title m-0 px-3"><span [translate]="'GREATER.BANK_ACCOUNT_DETAIL'"> </span></h3>
                            </div>
                        </div>
                    </div>
                </div>
                <!--end breadcrumb-->

                <!-- Section Wrap Start -->
                <section class="inner-section-wrap dark-bg p-4 border-radius5">
                    <div class="custom-form custom-form-2">
                        <form autocomplete="off" [formGroup]='bankData'>
                            <div class="row" *ngIf="showview">
                                <div class="col-12 col-sm-6">
                                    <div class="form-group pb-4">
                                        <label class="text-uppercase pb-2 text-uppercase" for="account_holder_name"><span [translate]="'GREATER.ACCOUNT_HOLDER_NAME'"> </span>  </label>
                                        <input type="text" class="form-control" id="account_holder_name" [(ngModel)]='detail.account_holder_name' placeholder="{{ 'GREATER.ACCOUNT_HOLDER_NAME' | translate }}" formControlName="name" [ngClass]="{ 'is-invalid': submitted && f.name.errors }">
                                        <small id="" class="orange-color d-inline-block pt-2" *ngIf="submitted && f.name.errors"> 
                                            <div *ngIf="f['name'].errors['required']"> <span [translate]="'GREATER.ACCOUNT_HOLDER_NAME_IS_REQUIRED'"> </span></div>
                                            <div *ngIf="f['name'].errors['pattern']"> <span [translate]="'GREATER.TEXT_ONLY_CHECK'"> </span></div>
                                        </small>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6">
                                    <div class="form-group pb-4 custom-select-box">
                                        <label class="text-uppercase pb-2 text-uppercase" for="account_holder_type"><span [translate]="'GREATER.ACCOUNT_HOLDER_TYPE'"> </span></label>
                                        
                                        <input type="text" class="form-control text-capitalize" id="account_holder_type" [(ngModel)]='detail.account_holder_type' formControlName="type" [ngClass]="{ 'is-invalid': submitted && f.type.errors }" [disabled]="true" readonly  >
<!-- <mat-form-field> -->
                                            <!-- <input type="text" class="form-control" id="currency" [(ngModel)]='detail.currency' placeholder="{{ 'GREATER.CURRENCY' | translate }}" formControlName="currency" [ngClass]="{ 'is-invalid': submitted && f.currency.errors }" [disabled]="true" readonly>
                                            <input type="text" class="form-control" id="currency" [(ngModel)]='detail.currency' placeholder="{{ 'GREATER.CURRENCY' | translate }}" formControlName="currency" [ngClass]="{ 'is-invalid': submitted && f.currency.errors }" [disabled]="true" readonly>
                                             disabled *ngIf="loginDetail.user_role_type ==3"  disabled *ngIf="loginDetail.user_role_type ==2"
 -->
                                        <!-- </mat-form-field> -->
                                        <!-- <input type="text" class="form-control" id="account_holder_type"  placeholder="{{ 'GREATER.ACCOUNT_HOLDER_TYPE' | translate }}" formControlName="type" [ngClass]="{ 'is-invalid': submitted && f.type.errors }"> -->
                                        <small id="" class="orange-color d-inline-block pt-2" *ngIf="submitted && f.type.errors"> <span [translate]="'GREATER.ACCOUNT_HOLDER_TYPE_IS_REQUIRED'"> </span> </small>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6">
                                    <div class="form-group pb-4">
                                        <label class="text-uppercase pb-2 text-uppercase" for="account_number"><span [translate]="'GREATER.ACCOUNT_NUMBER'"> </span>   </label>
                                        <input type="text" minlength="6" maxlength="20" class="form-control" id="account_number" [(ngModel)]='detail.account_number' placeholder="{{ 'GREATER.ACCOUNT_NUMBER' | translate }}" formControlName="number" [ngClass]="{ 'is-invalid': submitted && f.number.errors }"
                                            (keypress)="service.numberOnly($event)" onKeyPress="if(this.value.length >= 19) return false;" onkeyup="this.value=this.value.replace(/^\s+/g, '')">
                                        <small id="" class="orange-color d-inline-block pt-2" *ngIf="submitted && f.number.errors"> 
                                            <div *ngIf="f['number'].errors['required']"><span  [translate]="'GREATER.ACCOUNT_NUMBER_IS_REQUIRED'"></span></div>
                                            <div *ngIf="f['number'].errors['minlength']"> <span [translate]="'GREATER.MINIMUM'"> </span>6 </div>
                                            <div *ngIf="f['number'].errors['maxlength']"> <span [translate]="'GREATER.MAXIMUM'"> </span>20 </div>
                                        </small>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6">
                                    <div class="form-group pb-4">
                                        <label class="text-uppercase pb-2 text-uppercase" for="routing_number"><span [translate]="'GREATER.ROUTING_NUMBER'"> </span> </label>
                                        <input type="text" minlength="9"  class="form-control" id="routing_number" [(ngModel)]='detail.routing_number' placeholder="{{ 'GREATER.ROUTING_NUMBER' | translate }}" formControlName="r_number" [ngClass]="{ 'is-invalid': submitted && f.r_number.errors }"
                                            onkeyup="this.value=this.value.replace(/^\s+/g, '')">
                                        <small id="" class="orange-color d-inline-block pt-2" *ngIf="submitted && f.r_number.errors"> 
                                            <div *ngIf="f['r_number'].errors['required']"><span [translate]="'GREATER.ROUTING_NUMBER_IS_REQUIRED'"> </span></div> 
                                            <div *ngIf="f['r_number'].errors['minlength']"> <span [translate]="'GREATER.MINIMUM'"> </span> 9</div>
                                        </small>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6">
                                    <div class="form-group pb-4 custom-select-box">
                                        <label class="text-uppercase pb-2 text-uppercase" for="Country"><span [translate]="'GREATER.COUNTRY'"> </span> </label>
                                        <mat-form-field>
                                            <mat-select class="form-select" [(value)]="detail.countrys" [(ngModel)]='detail.countrys' (selectionChange)="getState($event,1)" formControlName="country" [ngClass]="{ 'is-invalid': submitted && f.country.errors }">
                                                <mat-option value="" disabled hidden selected><span [translate]="'GREATER.SELECT'"> </span></mat-option>
                                                <mat-option *ngFor="let item of countryList" [value]="item._id">
                                                    {{item.name}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <!-- <input type="text" class="form-control" id="Country" [(ngModel)]='detail.country' placeholder="{{ 'GREATER.COUNTRY' | translate }}" formControlName="country" [ngClass]="{ 'is-invalid': submitted && f.country.errors }"> -->
                                        <small id="" class="orange-color d-inline-block pt-2" *ngIf="submitted && f.country.errors"> <span [translate]="'GREATER.COUNTRY_IS_REQUIRED'"> </span> </small>
                                    </div>
                                </div>
                                <div class="col-12 col-sm-6">
                                    <div class="form-group pb-4">
                                        <label class="text-uppercase pb-2 text-uppercase" for="currency"><span [translate]="'GREATER.CURRENCY'"> </span></label>
                                        <input type="text" class="form-control" id="currency" [(ngModel)]='detail.currency' placeholder="{{ 'GREATER.CURRENCY' | translate }}" formControlName="currency" [ngClass]="{ 'is-invalid': submitted && f.currency.errors }" [disabled]="true" readonly>
                                        <small id="" class="orange-color d-inline-block pt-2" *ngIf="submitted && f.currency.errors"> <span [translate]="'GREATER.CURRENCY_IS_REQUIRED'"> </span> </small>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="btn-box">
                                        <button type="submit" class="btn custom-btn gradient1-btn" (click)="Onsubmit()">
                                            <span [translate]="'GREATER.UPDATE'" *ngIf="currentUrl=='/edit-bank-detail'"> </span>
                                            <span [translate]="'GREATER.SEND'"  *ngIf="currentUrl!='/edit-bank-detail'"> </span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </section>
                <!-- Section Wrap End -->

            </div>

            <!-- Start Create Subscription Album -->
            <div class="page-content d-none" *ngIf="currentUrl=='/bank-detail'">

                <!--breadcrumb-->
                <div class="page-breadcrumb mb-1 pb-3">
                    <div class="row align-items-center">
                        <div class="col-12">
                            <h3 class="breadcrumb-title m-0 pe-3"><span [translate]="'GREATER.SAVED_BANK_DETAIL'"> </span> </h3>
                        </div>
                    </div>
                </div>
                <!--end breadcrumb-->

                <!-- Section Wrap Start -->
                <section class="inner-section-wrap bank-detail-section">

                    <div class="row row-cols-1 row-cols-sm-2 row-cols-xl-2">
                        <!-- start Coulam -->
                        <div class="col">
                            <div class="card dark-bg border-radius20">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-12 col-sm-6">
                                            <div class=" border-bottom py-3">
                                                <h6 class="font-14"><span [translate]="'GREATER.ACCOUNT_HOLDER_NAME'"> </span> </h6>
                                                <p class="grey-color font-12"> {{detail.accountName}} </p>
                                            </div>
                                        </div>
                                        <div class="col-12 col-sm-6">
                                            <div class=" border-bottom py-3">
                                                <h6 class="font-14"><span [translate]="'GREATER.ACCOUNT_HOLDER_TYPE'"> </span> </h6>
                                                <p class="grey-color font-12"> {{detail.account_type}} </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12 col-sm-6">
                                            <div class=" border-bottom py-3">
                                                <h6 class="font-14"><span [translate]="'GREATER.ACCOUNT_NUMBER'"> </span> </h6>
                                                <p class="grey-color font-12"> {{detail.account_number}} </p>
                                            </div>
                                        </div>
                                        <div class="col-12 col-sm-6">
                                            <div class=" border-bottom py-3">
                                                <h6 class="font-14"><span [translate]="'GREATER.ROUTING_NUMBER'"> </span> </h6>
                                                <p class="grey-color font-12"> {{detail.routing_number}} </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-12 col-sm-6">
                                            <div class=" border-bottom py-3">
                                                <h6 class="font-14"><span [translate]="'GREATER.CURRENCY'"> </span> </h6>
                                                <p class="grey-color font-12"> {{detail.currency}} </p>
                                            </div>
                                        </div>
                                        <div class="col-12 col-sm-6">
                                            <div class=" border-bottom py-3">
                                                <h6 class="font-14"><span [translate]="'GREATER.COUNTRY'"> </span> </h6>
                                                <p class="grey-color font-12"> {{detail.country}} </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- End Coulam -->
                    </div>

                </section>
                <!-- Section Wrap End -->

            </div>
        </div>
    </div>
    <button type="submit" class="btn custom-btn gradient1-btn" (click)="checks()" id="text23" style="display :none;"></button>
    <app-footer></app-footer>
</main>